import React ,{useState,useEffect}from 'react'
import axios from 'axios';
import {Link} from 'react-router-dom';
import './Leads.css';



 const Leads=()=>{
    
    const [user,setUser]=useState([]);
   
    useEffect(()=>{
           LoadUsers();
     },[]);

    const LoadUsers=async()=>{
        const data=await axios.get(`http://localhost/3000/users`);
        setUser(data.data);
    };

LoadUsers();
    return ( 
     <div >
        <h1>Leads</h1>
        <div className="user-cards">
            <div className="user-card" key={user.id}>
                <h2>Full Name:{user.name}</h2>
                <h3>Mobile:{user.mobile}</h3>
                <h3>Email:{user.email}</h3>
                <h3>Message:</h3>
                <h4>{user.message}</h4>
            </div>
        </div>             
     </div>
    );
};

export default Leads;
